import React from 'react';
import { AlertTriangle } from 'lucide-react';

// CRM pop-up for staff: the customer's service expired more than 90 days ago (backend
// utils/expiryOver90.js). Shown when the customer page opens and when the Collect/Renew panel
// opens. Informational only — staff can still record a payment after "OK".
export default function Over90DaysNotice({ info, onClose }) {
  if (!info) return null;
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 10000, padding: 16,
    }} onClick={onClose}>
      <div role="alertdialog" aria-modal="true" aria-labelledby="over90-title" style={{
        background: '#fff', borderRadius: 14, width: '100%', maxWidth: 380,
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)', padding: '22px 20px',
      }} onClick={(e) => e.stopPropagation()}>
        <div style={{
          width: 46, height: 46, borderRadius: 12, background: '#fee2e2', display: 'flex',
          alignItems: 'center', justifyContent: 'center', marginBottom: 14,
        }}>
          <AlertTriangle size={22} color="#b91c1c" />
        </div>
        <div id="over90-title" style={{ fontSize: '1.02rem', fontWeight: 800, color: '#1e293b', marginBottom: 8 }}>
          Customer is over 90 days
        </div>
        <div style={{ fontSize: '.87rem', color: '#475569', lineHeight: 1.55 }}>
          This customer's expiry was <b>{info.days} days ago</b>. Their portal shows a "please contact
          {info.contact ? ` ${info.contact}` : ''} for reactivation" message and online payment is blocked.
        </div>
        <button type="button" className="btn btn-primary" onClick={onClose} style={{ width: '100%', justifyContent: 'center', marginTop: 18 }} autoFocus>
          OK
        </button>
      </div>
    </div>
  );
}
